<script>
export default {
    name: "TheatreRequestsForm",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

      "prescription-tab": () => import('./tabs/Prescription.vue'),
      "none-drug-treatment-tab": () => import('./tabs/NoneDrugTreatment.vue'),
      "procedure-tab": () => import('./tabs/Procedure.vue'),
      "consultation-request-tab": () => import('./tabs/ConsultationRequest.vue'),
      "lab-request-tab": () => import('./tabs/LabRequest.vue'),
      "imaging-request-tab": () => import('./tabs/ImagingRequest.vue'),
      "direct-input-tab": () => import('./tabs/DirectInput.vue'),
    },
}
</script>
<template>
<div class="flex flex-wrap mt-1">
    <ul class="flex border-b border-gray-500 w-full">
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=0" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
            :class="active == 0 ? activeClass : inActiveClass">Prescription</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=1"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
            :class="active == 1 ? activeClass : inActiveClass">None Drug Treatment</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=2"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
            :class="active == 2 ? activeClass : inActiveClass">Procedures</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=3"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
            :class="active == 3 ? activeClass : inActiveClass">Consultation Request</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=5" 
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
            :class="active == 5 ? activeClass : inActiveClass">Lab Request</a>
      </li>
      <li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=6"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
            :class="active == 6 ? activeClass : inActiveClass">Imaging Request</a>
      </li><li class="-mb-px mr-1">
          <a href="javascript:void(0)" @click.prevent="active=7"
            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
            :class="active == 7 ? activeClass : inActiveClass">Direct Input</a>
      </li>
    </ul>
      <prescription-tab v-if="active==0" />
      <none-drug-treatment-tab v-if="active==1" />
      <procedure-tab v-if="active==2"/>
      <consultation-request-tab v-if="active==3" />
      <lab-request-tab v-if="active==5"/>
      <imaging-request-tab v-if="active==6"/>
      <direct-input-tab v-if="active==7"/>
</div>
</template>